import { Injectable } from '@angular/core';
import { Observable, firstValueFrom } from "rxjs";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { CashOutModel } from "./externalCashOut.model";
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ExternalCashOutService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getTransaction(id: string) {
    const params = new HttpParams().set('id', id);
    return this.http.get<any>(`${environment.intlUrl}/transaction/cashInCashOut`, { params });
  }

  updateTransaction(body: any) {
    return this.http.post<any>(`${environment.intlUrl}/withdrawpayment`, body);
  }

  getEnum(): Promise<any> {
    const origin = this.authService.getOriginCurrency();
    let queryParams = new HttpParams();
    queryParams = queryParams.append('origin', origin);

    return firstValueFrom(
      this.http.get<any>(`${environment.apiUrl}/enum`, { params: queryParams })
    );
  }

  public sendDeposit(request: CashOutModel): Observable<any> {
    return this.http.post<any>(this.url('/deposit'), request);
  }

  getBankCodes(originCurrency: string, payMethod: string) {
    let params = new HttpParams()
      .set('originCurrency', originCurrency)
      .set('payMethod', payMethod);

    return this.http.get<any>(`${environment.intlUrl}/getbankcode`, { params });
  }

  getPersonUser(email: string, originCurrency: string) {
    const params = new HttpParams()
      .set('email', email)
      .set('originCurrency', originCurrency);
    return this.http.get<any>(`${environment.intlUrl}/getpersonuser`, { params });
  }
}
